import React from 'react';

export default () => (
  <svg
    width="252"
    height="126"
    viewBox="0 0 252 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.4">
      <path
        d="M63.7618 104.412C65.8743 105.146 66.97 107.437 66.2425 109.513C65.515 111.588 63.2258 112.703 61.1133 111.968C59.0008 111.233 57.9052 108.942 58.6326 106.867C59.3601 104.791 61.6493 103.677 63.7618 104.412Z"
        stroke="url(#paint2_linear)"
        strokeWidth="8"
      />
      <path
        d="M63.7618 104.412C65.8743 105.146 66.97 107.437 66.2425 109.513C65.515 111.588 63.2258 112.703 61.1133 111.968C59.0008 111.233 57.9052 108.942 58.6326 106.867C59.3601 104.791 61.6493 103.677 63.7618 104.412Z"
        stroke="url(#paint3_angular)"
        strokeWidth="8"
      />
    </g>
    <path
      d="M127.192 1.98782C125.96 1.28142 124.445 1.28141 123.213 1.98782L73.0106 30.768C71.767 31.4809 71 32.8047 71 34.2382V91.7618C71 93.1953 71.767 94.5191 73.0106 95.232L123.213 124.012C124.445 124.719 125.96 124.719 127.192 124.012L177.394 95.232C178.638 94.5191 179.405 93.1953 179.405 91.7618V34.2382C179.405 32.8047 178.638 31.4809 177.394 30.768L127.192 1.98782Z"
      fill="#F5F8FF"
      stroke="#DBE1EB"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="72"
      y="2"
      width="107"
      height="122"
    >
      <path
        d="M123.71 2.85537C124.634 2.32556 125.77 2.32557 126.694 2.85537L176.897 31.6355C177.829 32.1702 178.405 33.1631 178.405 34.2382V91.7618C178.405 92.8369 177.829 93.8298 176.897 94.3645L126.694 123.145C125.77 123.674 124.634 123.674 123.71 123.145L73.5079 94.3645C72.5753 93.8298 72 92.8369 72 91.7618V34.2382C72 33.1631 72.5753 32.1702 73.5079 31.6355L123.71 2.85537Z"
        fill="#B2C6EA"
      />
      <path
        d="M123.71 2.85537C124.634 2.32556 125.77 2.32557 126.694 2.85537L176.897 31.6355C177.829 32.1702 178.405 33.1631 178.405 34.2382V91.7618C178.405 92.8369 177.829 93.8298 176.897 94.3645L126.694 123.145C125.77 123.674 124.634 123.674 123.71 123.145L73.5079 94.3645C72.5753 93.8298 72 92.8369 72 91.7618V34.2382C72 33.1631 72.5753 32.1702 73.5079 31.6355L123.71 2.85537Z"
        fill="url(#paint4_linear)"
        fillOpacity="0.5"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M122.67 29.4707L151.265 37.6791L154.243 42.7098L142.915 82.1732L110.235 72.7922L122.67 29.4707Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M154.243 42.7098L151.265 37.6791L150.158 41.5372L154.243 42.7098Z"
        fill="#C4C4C4"
      />
      <rect
        opacity="0.6"
        x="125.578"
        y="38.1662"
        width="23.6111"
        height="1.41667"
        rx="0.472222"
        transform="rotate(16.0164 125.578 38.1662)"
        fill="#A1ACC9"
      />
      <rect
        opacity="0.6"
        x="124.275"
        y="42.7051"
        width="23.6111"
        height="1.41667"
        rx="0.472222"
        transform="rotate(16.0164 124.275 42.7051)"
        fill="#A1ACC9"
      />
      <rect
        x="122.973"
        y="47.2439"
        width="8.97222"
        height="1.41667"
        rx="0.472222"
        transform="rotate(16.0164 122.973 47.2439)"
        fill="#C4C4C4"
      />
      <rect
        x="133.412"
        y="50.2406"
        width="3.77778"
        height="1.41667"
        rx="0.472222"
        transform="rotate(16.0164 133.412 50.2406)"
        fill="#C4C4C4"
      />
      <g filter="url(#filter0_d)">
        <path
          d="M104.227 38.2244L133.958 37.1531L138.349 41.0113L139.208 64.8431L105.23 66.0674L104.227 38.2244Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M138.349 41.0114L133.958 37.1532L134.102 41.1645L138.349 41.0114Z"
          fill="#C4C4C4"
        />
        <rect
          x="109.69"
          y="45.5879"
          width="23.6111"
          height="1.41667"
          rx="0.472222"
          transform="rotate(-2.06368 109.69 45.5879)"
          fill="#A1ACC9"
        />
        <rect
          x="109.86"
          y="50.3071"
          width="23.6111"
          height="1.41667"
          rx="0.472222"
          transform="rotate(-2.06368 109.86 50.3071)"
          fill="#A1ACC9"
        />
        <rect
          x="110.03"
          y="55.0262"
          width="8.97222"
          height="1.41667"
          rx="0.472222"
          transform="rotate(-2.06368 110.03 55.0262)"
          fill="#A1ACC9"
        />
        <rect
          x="120.884"
          y="54.6352"
          width="3.77778"
          height="1.41667"
          rx="0.472222"
          transform="rotate(-2.06368 120.884 54.6352)"
          fill="#A1ACC9"
        />
      </g>
      <path
        d="M98 63.7468V92.2532C98 94.3225 99.8076 96 102.037 96H149.963C152.192 96 154 94.3225 154 92.2532V67.4304C154 65.3611 152.192 63.6835 149.963 63.6835H117.423C116.958 63.6835 116.509 63.5119 116.162 63.2014L114.373 61.5982C113.618 60.5965 112.383 60 111.066 60H102.037C99.8076 60 98 61.6775 98 63.7468Z"
        fill="#DEE3ED"
      />
    </g>
    <g opacity="0.4">
      <path
        d="M111.456 20.3334C111.456 28.0329 105.126 34.3453 97.2311 34.3453C89.3357 34.3453 83.0063 28.0329 83.0063 20.3334C83.0063 12.6338 89.3357 6.32145 97.2311 6.32145C105.126 6.32145 111.456 12.6338 111.456 20.3334Z"
        stroke="url(#paint5_linear)"
        strokeWidth="6.83333"
      />
      <path
        d="M111.456 20.3334C111.456 28.0329 105.126 34.3453 97.2311 34.3453C89.3357 34.3453 83.0063 28.0329 83.0063 20.3334C83.0063 12.6338 89.3357 6.32145 97.2311 6.32145C105.126 6.32145 111.456 12.6338 111.456 20.3334Z"
        stroke="url(#paint6_angular)"
        strokeWidth="6.83333"
      />
    </g>
    <g opacity="0.5">
      <path
        d="M214.36 99.9423C215.087 106.428 210.397 112.289 203.863 113.016C197.328 113.743 191.456 109.057 190.729 102.571C190.002 96.0851 194.692 90.224 201.226 89.4972C207.76 88.7704 213.633 93.4565 214.36 99.9423Z"
        stroke="url(#paint7_linear)"
        strokeWidth="4.83"
      />
      <path
        d="M214.36 99.9423C215.087 106.428 210.397 112.289 203.863 113.016C197.328 113.743 191.456 109.057 190.729 102.571C190.002 96.0851 194.692 90.224 201.226 89.4972C207.76 88.7704 213.633 93.4565 214.36 99.9423Z"
        stroke="url(#paint8_angular)"
        strokeWidth="4.83"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="104.227"
        y="37"
        width="35.9812"
        height="30.0674"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1" dy="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="127.719"
        y1="33.2258"
        x2="126.73"
        y2="119.008"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C98B3" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="259.383"
        y1="67.5806"
        x2="-1.53446"
        y2="79.0219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="0.078125" stopColor="white" stopOpacity="0" />
        <stop offset="0.916667" stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="57.6861"
        y1="99.7588"
        x2="66.8685"
        y2="118.254"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E1E2EA" />
        <stop offset="1" stopColor="#BFC3D4" />
      </linearGradient>
      <radialGradient
        id="paint3_angular"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(62.4376 108.19) rotate(166.358) scale(7.99221 7.96403)"
      >
        <stop stopColor="white" stopOpacity="0.6" />
        <stop offset="0.267072" stopColor="white" stopOpacity="0.3" />
        <stop offset="0.515625" stopColor="white" stopOpacity="0" />
        <stop offset="0.752548" stopColor="white" stopOpacity="0.3" />
      </radialGradient>
      <linearGradient
        id="paint4_linear"
        x1="146.679"
        y1="2"
        x2="103.777"
        y2="130.474"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="111.344"
        y1="4.54512"
        x2="79.9849"
        y2="37.1173"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E1E2EA" />
        <stop offset="1" stopColor="#BFC3D4" />
      </linearGradient>
      <radialGradient
        id="paint6_angular"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(97.2311 20.3334) rotate(-123.257) scale(17.4093 17.4948)"
      >
        <stop stopColor="white" stopOpacity="0.6" />
        <stop offset="0.267072" stopColor="white" stopOpacity="0.3" />
        <stop offset="0.515625" stopColor="white" stopOpacity="0" />
        <stop offset="0.752548" stopColor="white" stopOpacity="0.3" />
      </radialGradient>
      <linearGradient
        id="paint7_linear"
        x1="212.479"
        y1="87.1649"
        x2="189.935"
        y2="116.251"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E1E2EA" />
        <stop offset="1" stopColor="#BFC3D4" />
      </linearGradient>
      <radialGradient
        id="paint8_angular"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(202.544 101.257) rotate(-129.423) scale(14.2028 14.2139)"
      >
        <stop stopColor="white" stopOpacity="0.6" />
        <stop offset="0.267072" stopColor="white" stopOpacity="0.3" />
        <stop offset="0.515625" stopColor="white" stopOpacity="0" />
        <stop offset="0.752548" stopColor="white" stopOpacity="0.3" />
      </radialGradient>
    </defs>
  </svg>
);
